import { Injectable } from '@angular/core';
import {
    IAccountingBasisDTO,
    IAccountingBasisExtendedDTO,
    ICurrencyDTO,
    ILegalFormDTO,
    ILegalFormExtendedDTO,
} from '@modeso/types__aumico-lib-settings-be';
type Settings = IAccountingBasisExtendedDTO[] | ILegalFormExtendedDTO[];
type BaseSettings = IAccountingBasisDTO[] | ILegalFormDTO[];
@Injectable({
    providedIn: 'root',
})
export class BaseObjectsMapper {
    public getBaseCurrencies(currencies: ICurrencyDTO[]): ICurrencyDTO[] {
        const baseCurrencies: ICurrencyDTO[] = [];

        for (const currentObject of currencies) {
            const baseCurrency: ICurrencyDTO = {
                _id: currentObject._id,
                name: currentObject.name,
                text: currentObject.text,
            };

            baseCurrencies.push(baseCurrency);
        }

        return baseCurrencies;
    }

    public getBaseLegalFormsOrAccountBases(legalFormsOrAccountBases: Settings): BaseSettings {
        const bases: BaseSettings = [];

        for (const iterator of legalFormsOrAccountBases) {
            bases.push({
                _id: iterator._id,
                name: iterator.name,
                text: iterator.text,
            });
        }
        return bases;
    }
}
